let config = {
	request: {
		// #ifdef H5
		baseUrl: window.location.protocol + "//" + window.location.host+"/api",
		// #endif
		// #ifdef APP-PLUS || APP-PLUS
		baseUrl: 'https://sc.whjshy.site/api',
		// #endif
		// #ifdef MP-WEIXIN
		baseUrl: 'https://sc.whjshy.site/api', // 微信小程序环境
		// #endif
		header: {
			'content-type': 'application/json'
		},
		timeout: 60000,
		dataType: "json",
		responseType: "text"
	}
}

if(process.env.NODE_ENV === "development"){
	config.request.baseUrl = "https://sc.whjshy.site/api";
}

export default config;